<template>
  <div v-if="content">
    <h1 class="title">{{ content.title }}</h1>
    <div class="instructions">
      <div
        class="instructions__wrapper"
        v-for="(instruction, index) in content.instructions"
        :key="`instruction_${index}`"
      >
        <h2>{{ instruction.step }}</h2>
        <p>{{ instruction.body }}</p>
      </div>
    </div>
    <div class="signature">
      <div class="signature__form">
        <div
          class="signature__form--field"
          v-for="(field, index) in content.fields"
          :key="`field_${index}`"
        >
          <h2>{{ field.title }}</h2>
          <select v-if="field.options" v-model="form[index]">
            <option disabled selected>
              {{ field.placeholder }}
            </option>
            <option
              v-for="(brand, index) in field.options"
              :key="`brand_${index}`"
              :value="brand"
            >
              {{ brand.name }}
            </option>
          </select>
          <input
            v-else
            type="text"
            :placeholder="field.placeholder"
            v-model="form[index]"
          />
        </div>
      </div>
      <div class="signature__output">
        <div class="signature__output--wrapper" ref="signature">
          <h1
            style="color: #ff8001; margin: 0; font-weight: 600; font-size: 18px"
          >
            {{ form[0] }}
          </h1><p v-if="form[2].value !== 'n/a'" class="pronouns">({{ form[2].value }})</p><a v-if="form[2].value !== 'n/a'" class="learn" href="https://www.inclusiveemployers.co.uk/blog/why-we-use-pronouns-in-signatures/?cn-reloaded=1" target="_blank">(What is this?)</a>
          <h2
            v-if="form[1]"
            style="
              color: #6b6e71 !important;
              margin: 0 0 15px 0;
              font-weight: 600;
              font-size: 14px;
            "
          >
            {{ form[1] }}
          </h2>
          <h4
            v-if="form[3]"
            style="
              text-decoration: underline;
              color: #6b6e71 !important;
              margin: 0;
              font-weight: 300;
              font-size: 12px;
            "
          >
            E: {{ form[3] }}
          </h4>
          <h4
            v-if="form[4]"
            style="
              text-decoration: underline;
              color: #6b6e71 !important;
              margin: 0;
              font-weight: 300;
              font-size: 12px;
            "
          >
            M: {{ form[4] }}
          </h4>
          <h4
            v-if="form[5]"
            style="
              text-decoration: underline;
              color: #6b6e71 !important;
              margin: 0;
              font-weight: 300;
              font-size: 12px;
            "
          >
            P: {{ form[5] }}
          </h4>
          <h4
            v-if="form[6]"
            style="
              text-decoration: underline;
              color: #6b6e71 !important;
              margin: 0;
              font-weight: 300;
              font-size: 12px;
            "
          >
            W: {{ form[6] }}
          </h4>
          <h4
            v-if="form[7]"
            style="
              margin-top: 15px;
              white-space: pre-line;
              color: #6b6e71 !important;
              font-weight: 300;
              font-size: 12px;
            "
          >
            {{ form[7].value }}
          </h4>
          <img :style="`width: ${form[8].width}px`" :src="form[8].value" />
        </div>
        <button @click="copySignature" class="copy-button">
          Copy Signature
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "../../data/content.js";

export default {
  name: "SignatureGenerator",
  data() {
    return {
      content: Content,
      form: [
        "Your Name",
        "Your Job",
        {
          name: "n/a",
          value: "n/a",
        },
        "your.name@justeattakeaway.com",
        "00000000000",
        "00000000000",
        "www.justeattakeaway.com",
        {
          name: "London (Fleet Place House)",
          value: "Fleet Place House, \n2 Fleet Place, \nLondon, \nEC4M 7RF",
        },
        {
          value:
            "https://www.just-eat.co.uk/CmsAssets/media/files/assets/brands/signatureLogos/new/justeat.png",
          name: "Just Eat",
          width: 180,
        },
      ],
    };
  },
  methods: {
    copySignature() {
      this.selectText(this.$refs.signature);
      document.execCommand("copy");
    },
    selectText(element) {
      let range;
      if (document.selection) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
  },
};
</script>

<style lang="scss">
.title {
  color: var(--colour-white-1);
  text-align: center;
}
.instructions {
  display: flex;
  padding: 0 10%;
  &__wrapper {
    color: var(--colour-white-1);
    width: 33%;
    text-align: center;
    padding: 30px;
  }
}
.signature {
  display: flex;
  padding: 0 10%;
  &__form {
    width: 50%;
    padding: 30px;
    &--field {
      h2 {
        font-size: 18px;
        color: var(--colour-white-1);
        text-align: left;
        max-width: 100%;
      }
      input {
        width: 400px;
      }
      select {
        width: 420px;
        cursor: pointer;
      }
      input,
      select {
        padding: 10px;
        border-radius: 5px;
        border: none;
      }
    }
  }
  &__output {
    margin-top: 55px;
    width: 40%;
    min-height: 600px;
    &--wrapper {
      background-color: var(--colour-white-1);
      padding: 20px;
      border-radius: 10px;
      margin-bottom: 20px;
      h1,
      h2 {
        max-width: 100%;
        text-align: left;
        text-transform: none;
        margin: 0;
        padding: 0;
        line-height: 24px;
      }

      h1 {
        display: inline-block;
      }
      .pronouns {
        color: #ff8001;
        display: inline-block;
        margin: 0 0 0 5px;
        font-size: 10px;
        font-weight: 600;
      }

      .learn {
        font-size: 10px;

      }
    }
  }
  .copy-button {
    background-color: var(--colour-blue-1);
    color: var(--colour-white-1);
    padding: 15px;
    display: block;
    border-radius: 5px;
    border: none;
    width: 100%;
    font-weight: 600;
    font-size: 20px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}

@media screen and (max-width: 768px) {
  .logo {
    width: 200px !important;
  }
  .instructions {
    display: block;
    padding: 0 20px;
    text-align: center;
    &__wrapper {
      width: 90%;
      padding: 5%;
    }
  }
  .signature {
    display: block;
    padding: 0 2%;
    &__form {
      width: 90%;
      padding: 5%;
      &--field {
        select {
          width: 100%;
        }
        input {
          width: 95%;
        }
      }
    }
    &__output {
      margin-top: 55px;
      width: 90%;
      padding: 5%;
      min-height: 600px;
    }
  }
}
</style>
